import {tweenValue} from "./tween";

function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}

function textFunction(value) {
  return function() {
    var value1 = value(this);
    this.textContent = value1 == null ? "" : value1;
  };
}

export default function(value) {
  return this.tween("text", typeof value === "function"
      ? textFunction(tweenValue(this, "text", value))
      : textConstant(value == null ? "" : value + ""));
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-transition/src/transition/text.js
// module id = 726
// module chunks = 4